var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg785D20C33Fcef007179E9D33C99C7E7Addd40Fc5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1009 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 3",
    filter: "url(#filter0_f_2002_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 52.5H956.5",
    stroke: "url(#paint0_linear_2002_114)",
    strokeWidth: 17,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M52.5 52.5H956.5",
    stroke: "url(#paint1_linear_2002_114)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M956.5 52.5L52.5 52.5",
    stroke: "url(#paint2_linear_2002_114)",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_114",
    x: 0,
    y: 0,
    width: 1009,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_2002_114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_114",
    x1: 52.5,
    y1: 53,
    x2: 956.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2002_114",
    x1: 52.5,
    y1: 53,
    x2: 956.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2002_114",
    x1: 956.5,
    y1: 52.9999,
    x2: 52.4998,
    y2: 53.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B14F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg785D20C33Fcef007179E9D33C99C7E7Addd40Fc5);
export default __webpack_public_path__ + "static/media/785d20c33fcef007179e9d33c99c7e7addd40fc5.0235261dbde70fb9d36e89316f0dd90d.svg";
export { ForwardRef as ReactComponent };